import axios from 'axios';
const http = axios.create({
  baseURL: 'https://hys.huyishi.com',
  /* import.meta.env.MODE === 'development'
      ? '/his'
      : 'https://imchat.1ms.cn/his', */
  timeout: 1e3 * 120,
});

http.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default http;
